import { CoordsObjectType } from "@/common/types";
import {
  useAdvancedMarkerRef,
  AdvancedMarker,
  InfoWindow,
} from "@vis.gl/react-google-maps";
import CustomTypography from "../Typography/CustomTypography";
import { cn } from "@/common/utils";
interface PickedMakersProps {
  position: CoordsObjectType;
  func: (event: any, index: number) => void;
  index: number;
  providers?: any[];
  full_address: string;
  isActions: boolean | undefined;
}

interface ExactObjData {
  building: any;
  vendors: any;
}
interface ProvidersData {
  exact: ExactObjData[];
  near_50: any[];
  near_300: any[];
}
interface InfoModalDataProps {
  providers: ProvidersData;
}

const networkStatus = {
  On_net: "On Net",
  Off_net: "Off Net",
  Near_net: "Near Net",
};
const networkStatusColors = {
  On_net: "green",
  Off_net: "error",
  Near_net: "yellow",
};

function InfoModalData({ providers }: InfoModalDataProps) {
  if (providers.exact.length !== 0 || providers.near_50.length > 0) {
    return (
      <>
        <p className="text-center font-kanit text-base font-semibold text-success-dark">
          Network Status: On Net
        </p>
        <p className="font-kanit text-base font-semibold pt-2 flex items-center">
          <CustomTypography as="p" weight={"semibold"}>
            Providers:
          </CustomTypography>
          <div className="flex gap-2 items-center justify-center">
            {providers.exact
              .reduce((acc: any[], el) => {
                return [...acc, ...el.vendors];
              }, []).length !== 0 ? providers.exact
              .reduce((acc: any[], el) => {
                return [...acc, ...el.vendors];
              }, [])
              .map((el: any) => (
                <CustomTypography
                  as="p"
                  size={"15px"}
                  className="pl-4"
                  weight={"semibold"}
                  color={
                    networkStatusColors[
                      el.networkStatus as keyof typeof networkStatusColors
                    ] as "error" | "yellow" | "green"
                  }
                >
                  {
                    networkStatus[
                      el.networkStatus as keyof typeof networkStatus
                    ]
                  }
                  :{el.count}
                </CustomTypography>
              )): 0}
          </div>
        </p>
      </>
    );
  }
  if (providers.near_300.length > 0) {
    return (
      <p className="text-center font-kanit text-base font-semibold text-yellow-500">
        Near Net
      </p>
    );
  }
  return (
    <p className="text-center font-kanit text-base font-semibold text-red-500">
      Off Net
    </p>
  );
}
function PickedMarkers({
  position,
  func,
  index,
  providers,
  full_address,
  isActions,
}: PickedMakersProps) {
  const [markerRef, marker] = useAdvancedMarkerRef();
  return (
    <AdvancedMarker
      ref={markerRef}
      position={position}
      onDragEnd={(event) => func(event, index)}
      draggable={!isActions}
    >
      <img src="/images/markerIcon.svg" alt="marker" />

      {marker && (
        <InfoWindow
          anchor={marker}
          headerDisabled
          zIndex={40}
          className={cn( !isActions ? "h-[80px]": '')}
        >
          <h2 className="font-kanit text-base font-medium">{full_address}</h2>
          {providers && (
            <InfoModalData providers={providers as unknown as ProvidersData} />
          )}
        </InfoWindow>
      )}
    </AdvancedMarker>
  );
}
export default PickedMarkers;
